<template>
    <v-container fluid class="my-0 px-0  py-0" v-if="tenantHasFeature('Scorecards.CloseRatio', current_tenant.ID)">
        <q-content-submenu ref="contentMenu"></q-content-submenu>
        <v-row wrap class="mx-7" :style="showSubmenu !== false ? 'padding-top:100px;' : ''">
            <v-col class="pa-0" cols="12" v-if="showSubmenu !== false">
                <q-close-ratio-data-table title="Close Ratios" :rows="50"></q-close-ratio-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue';
import QCloseRatioDataTable from '@/components/datatables/Stats/QCloseRatioDataTable.vue';
export default {
    props: {
        showSubmenu: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            
        }
    },
    mounted: function() {

    },
    computed: {
        
    },

    methods: {
       
    },

    watch: {
        
    },
    components: {
        QContentSubmenu,
        QCloseRatioDataTable
    }
}
</script>